import useExperiment from '@hooks/useExperiment.experiments'

export default function useForcedAddress() {
  const branchName = useExperiment('address-instructions')
  return branchName === 'show'
}
